import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from 'src/environments/environment';
import { initialBrokerPreset } from './core/broker/broker.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({
      theme: {
        // Broker-dependent: Chill purple or Quote Devil red, resolved from
        // the hostname (or ?brokerId= locally) before bootstrap.
        preset: initialBrokerPreset(),
        options: {
          darkModeSelector: false,
        },
      },
      ripple: true,
    }),
    DialogService,
    importProvidersFrom(
      MsalModule.forRoot(
        new PublicClientApplication({
          auth: {
            clientId: environment.application.clientId,
            authority: `https://login.microsoftonline.com/${environment.application.tenantId}`,
            // One build serves both broker domains (Chill / Quote Devil), so
            // the redirect URI must match whichever origin served the app.
            // Every broker origin must be registered as a SPA redirect URI on
            // the Entra app registration.
            redirectUri: window.location.origin,
            postLogoutRedirectUri: environment.application.postLogoutRedirectUri,
          },
          cache: {
            cacheLocation: 'localStorage',
          },
        }),
        {
          interactionType: InteractionType.Redirect,
          authRequest: {
            scopes: ['User.Read','group.read.all','GroupMember.Read.All'],
          },
        },
        {
          interactionType: InteractionType.Redirect,
          // MSAL Angular v5 matches these strictly: bare base URLs no longer
          // cover sub-paths, so each entry needs an explicit /* wildcard.
          protectedResourceMap: new Map([
            [
              `${environment.apiManagement.address}*`,
              environment.application.api.scopes,
            ],
            ['https://graph.microsoft.com/v1.0/me', ['user.read']],
            ['https://graph.microsoft.com/v1.0/groups/*', ['group.read.all']],
            [
              'https://management.azure.com/*',
              ['https://management.azure.com/user_impersonation'],
            ],
          ]),
        }
      )
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
};
